import { ClientRecordedWorkspaceActivity, WorkspaceActivityEventType } from "common/interfaces";
import { uuid } from "common/utils/uuid";
import { workspaces as workspacesApi } from "apis-v2/callables";
import getLogger from "js/core/logger";

const logger = getLogger();

type ActivityMethod<T extends ClientRecordedWorkspaceActivity["eventType"]> =
    Extract<ClientRecordedWorkspaceActivity, { eventType: T }>["method"];

type PresentationActivity<T extends ClientRecordedWorkspaceActivity["eventType"]> = {
    presentationId: string;
    workspaceId: string;
    method: ActivityMethod<T>;
};

async function recordWorkspaceActivity({
    presentationId,
    workspaceId,
    ...activity
}: ClientRecordedWorkspaceActivity & { presentationId: string; workspaceId: string }): Promise<void> {
    if (!presentationId || !workspaceId) {
        return;
    }

    try {
        await workspacesApi.recordActivity({
            workspaceId,
            presentationId,
            ...activity,
            operationId: uuid(),
        });
    } catch (error) {
        logger.error(error, "[workspaceActivity] Failed to record workspace activity", {
            presentationId,
            eventType: activity.eventType,
            method: activity.method,
        });
    }
}

export function recordPresentationShared({
    presentationId,
    workspaceId,
    method,
}: PresentationActivity<WorkspaceActivityEventType.PRESENTATION_SHARED>): Promise<void> {
    return recordWorkspaceActivity({
        presentationId,
        workspaceId,
        eventType: WorkspaceActivityEventType.PRESENTATION_SHARED,
        method,
    });
}

export function recordPresentationPresented({
    presentationId,
    workspaceId,
    method,
}: PresentationActivity<WorkspaceActivityEventType.PRESENTATION_PRESENTED>): Promise<void> {
    return recordWorkspaceActivity({
        presentationId,
        workspaceId,
        eventType: WorkspaceActivityEventType.PRESENTATION_PRESENTED,
        method,
    });
}
